import React, { FC } from 'react'

interface Props {
  size?: number
  color?: string
  className?: string
}

export const ChatInputSendIcon: FC<Props> = ({
  size = 32,
  color = '#FFFFFF',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <circle cx="16" cy="16" r="9.4" stroke={color} strokeWidth="1.2" />
      <path
        d="M16 12L16 20M16 12L12.5 15.5M16 12L19.5 15.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
